import React, { useState } from 'react';

const GenericCard = ({ title, subtitle, optionsMenu, statusTag = null, price = null, thumbnailUrl = null }) => {
  const [thumbError, setThumbError] = useState(false);
  const showThumb = thumbnailUrl && !thumbError;

  return (
    <div
      className=" rounded-lg bg-white p-4 flex flex-col relative h-full overflow-hidden"
      style={{ boxShadow: '0px 6px 26px #626B7D12' }}
    >
      <div>
        <div className="text-[18px] font-semibold text-[#38485C] opacity-100">
          {title || ''}
        </div>
        {(subtitle || price) && (
          <div className="flex items-center ">
            {subtitle && (
              <div className="text-[14px] font-semibold text-primary opacity-100">
                {subtitle || ''}
              </div>
            )}
            {price && (
              <>
              <div className="text-[14px] font-semibold text-primary opacity-100 mr-2 ml-2"> - </div>
              <div className="text-[14px] font-semibold text-primary opacity-100">
                {price}
              </div>
              </>
            )}
          </div>
        )}
      </div>

      {showThumb && (
        <div className="w-full mb-6 mt-3 rounded-lg overflow-hidden bg-gray-100 flex items-start justify-center" style={{ minHeight: 100, maxHeight: 140 }}>
          <img
            src={thumbnailUrl}
            alt=""
            className="max-h-[140px] w-auto object-contain"
            onError={() => setThumbError(true)}
          />
        </div>
      )}

      <div className="flex-grow"></div>

      {statusTag && (
        <div className="mt-auto">
          {statusTag}
        </div>
      )}
      {optionsMenu && (
        <div className="absolute bottom-2 right-2">{optionsMenu}</div>
      )}
    </div>
  );
};

export default GenericCard;
